import { render } from "./DynamicTitle.html?vue&type=template&id=25a49cf5&scoped=true&ts=true&external"
import script from "./DynamicTitle.vue?vue&type=script&lang=ts"
export * from "./DynamicTitle.vue?vue&type=script&lang=ts"

import "./DynamicTitle.scss?vue&type=style&index=0&id=25a49cf5&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25a49cf5"]])

export default __exports__